import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PATH_DASHBOARD } from "src/utils/paths";

export const Route = createFileRoute("/")({
	component: IndexRoute
});

function IndexRoute() {
	const navigate = useNavigate();

	useEffect(() => {
		navigate({ to: PATH_DASHBOARD.app.overview, replace: true });
	}, [navigate]);

	return null;
}
